import sound from './roll.wav';export default sound;